import createSetSelectedReturn from './setSelectedReturn';
import { selectedReturnVar } from '../reactiveVariables';

const setSelectedReturn = createSetSelectedReturn(selectedReturnVar);

export default setSelectedReturn;
